<template lang="pug">
teleport(to="body")
  .sdg-promo-backdrop(v-if="modelValue" @click="handleBackdropClick")
    .sdg-promo-dialog(@click.stop)
      button.sdg-promo-close(type="button" aria-label="Close" @click="handleClose")
        img(src="@/assets/icons/close.svg" alt="")

      img.sdg-promo-image(src="/images/city.jpeg" alt="San Diego skyline")

      h2.sdg-promo-title
        span Looking for more ways to support
        span.sdg-promo-title-highlight  San Diego Gives?

      p.sdg-promo-body
        | Discover nonprofits, campaigns and community initiatives making a difference
        |  across San Diego.

      el-button.sdg-promo-cta(
        type="primary"
        round
        size="large"
        @click="handleReturn"
      ) Return to San Diego Gives
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  clearCheckoutReturn,
  SAN_DIEGO_GIVES_ORG_PATH,
} from '@/utils/checkoutNavigation';
import { clearCartAfterSuccessfulCheckout } from '@/utils/clearCartAfterCheckout';

export default defineComponent({
  name: 'DialogSanDiegoGivesPromo',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const router = useRouter();
    const store = useStore();

    function handleClose() {
      emit('update:modelValue', false);
    }

    function handleBackdropClick() {
      handleClose();
    }

    function handleReturn() {
      clearCartAfterSuccessfulCheckout(store);
      clearCheckoutReturn();
      emit('update:modelValue', false);
      router.push(SAN_DIEGO_GIVES_ORG_PATH);
    }

    return {
      handleClose,
      handleBackdropClick,
      handleReturn,
    };
  },
});
</script>

<style lang="scss" scoped>
.sdg-promo-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.45);
  animation: sdgPromoFadeIn 0.25s ease;
}

.sdg-promo-dialog {
  position: relative;
  width: 100%;
  max-width: 22rem;
  padding: 1.75rem 1.5rem 1.5rem;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  text-align: center;
  animation: sdgPromoSlideUp 0.35s ease;

  @media (min-width: 768px) {
    max-width: 24rem;
    padding: 2rem 1.75rem 1.75rem;
  }
}

.sdg-promo-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0.55;

  img {
    width: 1rem;
    height: 1rem;
  }

  &:hover {
    opacity: 0.85;
  }
}

.sdg-promo-image {
  display: block;
  width: 100%;
  max-width: 14rem;
  height: auto;
  margin: 0 auto 1.25rem;
}

.sdg-promo-title {
  margin: 0 0 0.75rem;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.35;
  color: #1a1a1a;

  span {
    display: block;
  }
}

.sdg-promo-title-highlight {
  color: #0d9488;
}

.sdg-promo-body {
  margin: 0 0 1.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #4b5563;
}

.sdg-promo-cta {
  width: 100%;
  height: 3rem;
  font-size: 0.9375rem;
  font-weight: 700;
  border: none;
  background: linear-gradient(90deg, #0d9488 0%, #14b8a6 100%) !important;

  &:hover {
    background: linear-gradient(90deg, #0f766e 0%, #0d9488 100%) !important;
  }
}

@keyframes sdgPromoFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes sdgPromoSlideUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
